<template>
  <div>
    <v-progress-linear indeterminate color="white" v-show="loading" />
    <v-app-bar app color="primary" dark elevate-on-scroll>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="text-truncate">{{ screenName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-progress-circular indeterminate color="white" v-show="loading" />
      <v-spacer></v-spacer>
      <v-btn icon @click="openSearchDialog">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn icon @click="toggleNotificationDrawer">
        <v-badge
          :content="unreadCount"
          :value="unreadCount"
          color="red"
          overlap
        >
          <v-icon>{{ $store.state.isNotificationEnabled ? "mdi-bell" : "mdi-bell-off" }}</v-icon>
        </v-badge>
      </v-btn>
      <v-menu offset-y left bottom transition="slide-y-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-for="(item, index) in right_menu_items"
            :key="index"
            :to="item.route"
            router
          >            
            <v-list-item-title>{{ item.title }}</v-list-item-title>
            <v-list-item-icon>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-menu>    
    </v-app-bar>
    <!-- Logout confirmation dialog -->
    <v-dialog v-model="showConfirmationDialog" persistent max-width="400px">
      <v-card>
        <v-toolbar color="primary" dense flat>
          <v-toolbar-title class="justify-center">Confirm Logout</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showConfirmationDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title class="justify-center">
          Are you sure you want to logout?
        </v-card-title>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="doSignUserOut">Yes</v-btn>
          <v-btn color="secondary" @click="showConfirmationDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  
    <v-overlay 
        v-model="loading"
        class="align-center justify-center"
      >
        <v-progress-circular
          color="primary"
          size="64"
          indeterminate
        ></v-progress-circular>
    </v-overlay>

    <v-navigation-drawer 
       app 
       v-model="drawer" 
       temporary
      :width="$vuetify.breakpoint.mdAndUp ? '25%' : '90%'"
       >  
       <v-toolbar color="primary" dark>
        <v-toolbar-title>{{ companyName }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="drawer = false">
          <v-icon>mdi-menu-open</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- update alert -->
      <v-alert
        v-model="updateAvailable"
        dismissible
        color="amber darken-3"
        border="left"
        elevation="1"
        colored-border
        icon="mdi-package-up"
      >
        <v-row align="center">
          <v-col class="grow">
            Newer Version {{availableVersion}} Available
          </v-col>
          <v-col class="shrink">
            <v-btn  v-if="showUpdateButton" color="amber" @click="updateApp">Update</v-btn>
          </v-col>
        </v-row>        
      </v-alert>

      <v-layout column align-center>       
        <v-flex class="mt-1">
          <v-avatar size="100">
             <!-- Use a style binding to include CSS for the image -->
          <img v-if="userProfile && userProfile.USER_IMAGE"
              class="d-flex justify-center"
              :src="userProfile.USER_IMAGE"
              style="object-fit: contain; width: 100%; height: 100%;" />

          <img v-else-if="user && userImageSrc()"
              class="d-flex justify-center"
              :src="userImageSrc()"
              style="object-fit: contain; width: 100%; height: 100%;" />

          <v-icon v-else class="d-flex justify-center" @click="get_profile" style="font-size: 48px;">
            mdi-refresh
          </v-icon>        

          </v-avatar>
          <p class="subheading mt-3 d-flex justify-center">
            Hi, {{ userName() }}            
          </p>      
        </v-flex>
      </v-layout>  
      <v-list>
        <v-list-item>
          <v-list-item-icon>
            <v-icon @click="drawer = false">mdi-message</v-icon>
            </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title >
              Messages    
            </v-list-item-title>
            <v-list-item-subtitle>
              status
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list>    
      <!-- <v-subheader>Menu</v-subheader> -->
      <v-list-item @click="userimage" router to="/home">
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Home</v-list-item-title>
      </v-list-item>
      <v-list-group
        v-for="left_menu_item in left_menu_items"
        :key="left_menu_item.title"
        v-model="left_menu_item.active"
        :prepend-icon="left_menu_item.icon"
        :class="left_menu_item.visibility"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title
              :class="{ 'new-notification': hasNewSubItems(left_menu_item) }"
              v-text="left_menu_item.title"
            ></v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          v-for="subItem in left_menu_item.items"
          :key="subItem.title"
          :prepend-icon="subItem.icon"
          router
          :to="subItem.route"
          :class="[subItem.visibility, { 'highlight-new': subItem.isNew }]"
        >
          <v-list-item-content>
            <v-list-item-subtitle
              v-text="subItem.title"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      </v-list>
      <!-- admin menu -->
      <div v-if="isAdmin">
        <!-- <v-subheader>Dashboard</v-subheader> -->
        <recursive-menu-item
          v-for="(menu, index) in flattenedMenus"
          :key="index"
          :item="menu"
        ></recursive-menu-item>
      </div>

        <v-list>
        <v-list-group no-action prepend-icon="mdi-apps" class="mb-6">
        <template v-slot:activator>
          <v-list-item-title>App</v-list-item-title>
        </template>

        <!-- Notification Switch -->
        <v-list-item class="d-flex justify-space-between">
          <v-list-item-icon>
            <v-icon :color="$store.getters['pushNotificationPermission'].color">
              {{$store.getters['pushNotificationPermission'].icon}}
            </v-icon>
          </v-list-item-icon>
           <v-list-item-action-text>
            Notification
           </v-list-item-action-text>
          <v-list-item-action>
            <v-switch v-model="$store.state.isNotificationEnabled"
            @change="switchNotification()"></v-switch>
          </v-list-item-action>
          <span v-if="$store.getters['pushNotificationPermission'].state === 'denied'">
            Push notifications are denied.
          </span>
        </v-list-item>
        <v-list-item class="d-flex justify-space-between">
          <v-list-item-icon>
            <v-icon :color="$store.getters['locationPermission'].color">
                {{$store.getters['locationPermission'].icon}}
            </v-icon>            
          </v-list-item-icon>

          <v-list-item-action-text>
            Live Location
           </v-list-item-action-text>
          <v-list-item-action>
            <v-switch v-model="$store.state.isLiveTracking"
            @change="switchLivelocation()"></v-switch>
          </v-list-item-action>  
        </v-list-item>

        <!-- App Version and Update Button -->
        <v-list-item class="d-flex justify-space-between">         
           <v-list-item-action-text>
            Version: {{ appVersion }}
           </v-list-item-action-text>
          <v-list-item-action>
            <v-btn @click="checkUpdate" icon>
              <v-icon class="animated-icon" :class="{ 'rotate-infinite': isAnimating }" color="blue">mdi-cached</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <!-- Logout -->
        <v-list-item class="d-flex justify-space-between">
          <v-list-item-action-text>
            Logout
           </v-list-item-action-text>
          <v-list-item-action>
            <v-btn class="primary" @click="onSignout" icon>
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list-group>
    </v-list>
   
    <template v-slot:append> 
      <div class="d-flex justify-space-between">
        <v-divider></v-divider>
        <v-row no-gutters>
          <span class="font-italic" >Privacy Policy</span>
        </v-row>
        <v-row no-gutters>
          <span class="font-italic">Terms & Conditions</span> 
        </v-row>       
      </div> 
    </template>

    </v-navigation-drawer>
    <!-- Include the NotificationDrawer component -->
    <notification-drawer />
     <!-- Add a new dialog for search functionality -->
    <v-dialog 
        v-model="searchDialogOpen" 
        fullscreen 
        hide-overlay
        transition="dialog-top-transition"
        
      >
      <v-card color="rgba(201,218,242, 0.7)">
        <v-toolbar dark flat color="primary lighten-1">
          <v-toolbar-title>Search</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-hover>
            <template v-slot:default="{ hover }">
            <v-btn 
              icon 
              dark
              @click="searchDialogOpen = false" 
              :color="hover ? 'red' : 'default'"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            </template>
        </v-hover>       
        </v-toolbar>
        <v-card-text class='mt-2'>
          <v-autocomplete
            v-model="selectedMenuItem"
            :items="flattenedMenuItems"
            label="Search menu"
            item-text="breadcrumb"
            item-value="route"
            prepend-inner-icon="mdi-magnify"
            clearable
            outlined
            filled
            shaped
            color="primary darken-1"
            autofocus
            @change="navigateToMenuItem"
            background-color='white'
          >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title v-html="item.breadcrumb"></v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
          
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { APP_VERSION } from '@/version';
import secure_axios from "../services/secure_axios";
import RecursiveMenuItem from './RecursiveMenuItem.vue'
import NotificationDrawer from './NotificationDrawer.vue';

export default {
  components: {
    RecursiveMenuItem,
    NotificationDrawer
  },
  methods: {
    doSignUserOut() {
     this.$store.dispatch("signUserOut");
     this.showConfirmationDialog = false;
    //  this.$router.push("/");
    },
    onSignout() {
      this.showConfirmationDialog = true;
    },
    userimage() {
      return   this.user ? this.user.USER_IMAGE:''
    }, 
    userImageSrc() {
      return this.user ? `data:image/jpeg;base64,${this.user?.USER_IMAGE}` : '';
    },  
    userName() {
      return this.user ? this.user.USER_NAME : 'Guest';
    },
    async updateApp() {
      this.updateClicked = true;
      async()=>{
       await caches.keys().then(cacheNames => {
          cacheNames.forEach(cacheName => {
            caches.delete(cacheName);
          });
        });
      }
      if (navigator.serviceWorker) {
        try {
          const registration = await navigator.serviceWorker.getRegistration();

          if (registration && registration.installing) {
            // Prompt user for confirmation
            if (confirm('An update is available! Reload the app to apply it?')) {
              await registration.installing.activate(); // Activate update
              window.location.reload(); // Reload app
            }
          } else {
            console.log('No update to activate.');
          }
        } catch (error) {
          console.error('Error activating update:', error);
        }
      }
      this.updateAvailable = false;
      window.location.reload(true);
    },
    hasNewSubItems(menuItem) {
      return menuItem.items.some(subItem => subItem.isNew);
    },
    checkUpdate(){
      this.isAnimating = true;
      this.checkForUpdate();
      setTimeout(() => {
        this.isAnimating = false;
      }, 1000);
      if (this.appUpdateAvailable){this.updateAvailable = true;}
    },
    async checkForUpdates() {
      if (navigator.serviceWorker) {
        try {
          const registration = await navigator.serviceWorker.getRegistration();

          if (registration) {
            await registration.update(); // Trigger update check

            if (await registration.installing) {
              // Update available, show notification
              this.updateAvailable = true;
              console.log('Update available! Click "Update" to reload.');
            } else {
              console.log('No update available.');
            }
          } else {
            console.log('No service worker registered.');
          }
        } catch (error) {
          console.error('Error checking for updates:', error);
        }
      }
    },    
    checkForUpdate() {
      this.checkForUpdates()
      secure_axios.get('https://tritonfactsapi.ngrok.io/version')
        .then(response => {
          console.log('reqres',response.data.version)
          // const appVersion = response.headers['X-app-version'];
          // console.log("appVersion:",appVersion)
          // const existingVersion = window.env.PACKAGE_JSON.version;
          // console.log("existingVersion:",existingVersion)
          // if (appVersion !== existingVersion) {
          //   console.log('New app version available:', appVersion);
          // }
          let versionNumber =  response.data.version;
          // this.checkServiceworker()
          // Compare the version number with the current app's version
           if (versionNumber > APP_VERSION) {
          // If an update is available, show the update dialog
          this.availableVersion = versionNumber;
          this.updateAvailable = true;
          // this.latestVersion = versionNumber; 
          }else if(this.updateClicked){
            this.updateAvailable = false;
          }
        })
        .catch(error => {
         console.error('Error fetching version number:', error);
      });
    },
    switchNotification(){
      this.$store.dispatch('toggleNotification')
    },
    switchLivelocation(){
      if (this.$store.state.isLiveTracking) {
        this.$store.dispatch("startLocationTracking");
      } else {
        this.$store.dispatch("stopLocationTracking");
      }
    },
    checkOnline() {
      this.$toast.info("Messaging Coming Soon")
      if (navigator.onLine) {
        this.$store.dispatch("appOffline", false); // Assuming the action to set online status is named `appOnline`
      } else {
        this.$store.dispatch("appOffline", true); // Assuming the action to set offline status is named `appOffline`
      }
    },
    get_profile() {
      this.$store.dispatch("get_employee", { employ_id: this.user?.USER_EMP_DOCNO });
    },
    openSearchDialog() {
      this.searchDialogOpen = true;
    },
    navigateToMenuItem(route) {
      if (route) {
        this.$router.push(route);
        this.searchDialogOpen = false;
        this.drawer = false; // Close the drawer after navigation
      }
    },
    toggleNotificationDrawer() {
      this.$store.dispatch('notifications/toggleNotificationDrawer');
    }
  },

  computed: {
    user() {     
      return this.$store.getters.factsuser;      
    },  
    appUpdateAvailable() {     
      return this.$store.getters.updateAvailable;      
    }, 
    userProfile(){
      return this.$store.getters.userProfile;
    },
    isAdmin(){
      if(this.$store.getters.fbuserdata?.usertype == 1)
       return true;
      else
       return false;
    },    
    companyName(){
      return this.$store.getters.fbuserdata.company
    },
    screenName() {
      return this.$store.getters.screenName;
    },
    loading() {
      return this.$store.getters.loading;
    },
    token(){
      return this.$store.getters.authToken
    },
    showUpdateButton() {
      return this.updateAvailable && !this.updateClicked;
    },
    flattenedMenus() {
      return [
        ...this.adminMenus.adminMenu,
        ...this.adminMenus.appraisalMenu,
        ...this.adminMenus.appMenu,
        ...this.adminMenus.messMenu,
        ...this.adminMenus.logisticMenu,
        ...this.adminMenus.accomodationMenu
      ]
    },
    filteredMenuItems() {
      if (!this.searchQuery) {
        return this.menuItems;
      }
      const searchLower = this.searchQuery.toLowerCase();

      const filterItems = (items) => {
        return items.filter(item => {
          const matchesTitle = item.title.toLowerCase().includes(searchLower);
          const hasMatchingChildren = item.children && filterItems(item.children).length > 0;

          if (matchesTitle || hasMatchingChildren) {
            const filteredItem = { ...item };
            if (item.children) {
              filteredItem.children = filterItems(item.children);
            }
            return filteredItem;
          }

          return false;
        });
      };

      return filterItems(this.menuItems);
    },
    flattenedMenuItems() {
      const flattenItems = (items, parentTitle = '') => {
        return items.reduce((acc, item) => {
          const breadcrumb = parentTitle ? `${parentTitle} > ${item.title}` : item.title;
          if (item.route) {
            acc.push({
              breadcrumb,
              route: item.route,
              title: item.title
            });
          }
          if (item.children) {
            acc.push(...flattenItems(item.children, breadcrumb));
          }
          return acc;
        }, []);
      };

      return flattenItems(this.menuItems);
    },
    unreadCount() {
      const notifications = this.$store.state.notifications.notifications;
      const messages = this.$store.state.notifications.messages;
      return notifications.filter(n => !n.read).length + messages.filter(m => !m.read).length;
    },
    hasNewItems() {
     return this.left_menu_items.some(item => item.items.some(subItem => subItem.isNew));
    },   
  },

  watch: {
    user(value) {
      if (value == null || value == undefined) {
        // this.$router.push("/");
      }
    }, 
    token(value) {
      if (value == null || value == undefined) {
        this.$router.push("/");
      }
    },
    
  },

  data() {
    return {
      appVersion: APP_VERSION,
      availableVersion:'',
      isAnimating: false,
      showConfirmationDialog: false,
      updateAvailable: false,
      updateClicked: false,
      drawer: false,
      login:false,
      searchQuery: '',
      searchDialogOpen: false,
      selectedMenuItem: null,
      isApploading:false,
      right_menu_items: [
        { title: "New Lead", icon:"mdi-account-multiple-plus-outline",route: "/newsaleslead" },
        { title: "New Journal",icon:"mdi-notebook", route: "/journalentry" },
        { title: "New BRVAR", icon:"mdi-receipt-text-edit",route: "/newbrvar" },
        { title: "New Collection",icon:"mdi-cash-clock", route: "/newcollection" },
        { title: "New Leave", icon:"mdi-account-tie",route: "/newleave" },
        { title: "New Logistics",icon:"mdi-car",route: "/newLogistics" },
        { title: "Order",icon:'mdi-file-document-outline' },
        { title: "Picklist",icon:'mdi-clipboard-list-outline' },
        { title: "Load-doc",icon:'mdi-file-document-plus-outline' },
        
      ],
      left_menu_items: [
        {
          active: false,
          icon: "mdi-checkbox-multiple-marked-outline",
          title: "Activities",
          visibility: "",
          items: [
            {
              title: "My Profile",
              route: "/myprofile",
              icon: "mdi-account",
              visibility: "",
            },           
            {
              title: "Attendance",
              route: "/attendance",
              icon: "mdi-account",
              visibility: "",
            },
            { title: "Leaves", 
              icon: "mdi-account",
              route:"/leaves",
              visibility: "" 
            }, 
            { title: "Editorials", 
              icon: "mdi-newspaper",
              route:"/EditorialViewer",
              visibility: "" 
            },
            // { title: "Lunch Schedule", 
            //   icon: "mdi-account",
            //   route:"/lunchSchedule",
            //   visibility: "" 
            // }, 
            {
              title: "Calender",
              icon: "mdi-account",
              // route: "/Appointments",
              // route: "/maptest",
              // route: "/Planner",
              visibility: "",
            },         
            { title: "Chats", 
              icon: "mdi-message",
              // route:"/chat",
              visibility: "" 
            },
            
          ],
        },
        {
          active: false,
          icon: "mdi-store",
          title: "CRM",
          visibility: "",
          items: [
            { title: "Sales Forcast",
              icon: "mdi-account",
              // route: "/salesforcastslist"
            },
            { title: "Sales  Quotation",
              icon: "mdi-account",
              // route: "/salesquotationslist"
            },
            { title: "Sales Orders", 
            icon: "mdi-account",
            route:"/salesorderslist",
            visibility: "" 
            },
            { title: "Sales Leads",
              icon: "mdi-account",
              // route: "/salesleads"
            },
            { title: "Leads",
              icon: "mdi-account",
              route: "/leads"
            },
            { title: "BRVARs",
              icon: "mdi-account",
              route: "/brvars",
              visibility: "" 
            },
            {
              title: "Customers",
              icon: "mdi-account",
              route: "/customersummary",
            },
          ],
        },
        {
          active: false,
          icon: "mdi-chart-line",
          title: "Stats",
          visibility: "",
          items: [
            { title: "KPIs", icon: "mdi-account" },
            { title: "Incentives", icon: "mdi-account" },
            { title: "Employee Appraisal", icon: "mdi-account-star-outline",//route: "/employeeappraisal", 
              
            }, 
            { title: "Appraisal Report", icon: "mdi-account-star-outline",route: "/AppraisalViewer", isNew: false,}
          ],
        },
        {
          active: false,
          icon: "mdi-mower-on",
          title: "Operations",
          visibility: "",
          items: [
            { title: "Payment Collection", 
              icon: "mdi-account",
              route: "/collections" 
            },
            { title: "Pick-lists", 
              icon: "mdi-account",
              // route: "/picklist" 
            },
            { 
              title: "Despatch", 
              icon: "mdi-account",
              route: "/despatch",
            },
            { title: "Deliveries", 
              icon: "mdi-account",
              route: "/deliveries",
            },
          ],
        },
      ],
      menuItems: [
        {
          id: 1,
          title: "Activities",
          icon: "mdi-checkbox-multiple-marked-outline",
          children: [
            { id: 11, title: "My Profile", icon: "mdi-account", route: "/myprofile" },
            { id: 12, title: "Attendance", icon: "mdi-account", route: "/attendance" },
            { id: 13, title: "Leaves", icon: "mdi-account", route: "/leaves" },
            { id: 14, title: "Editorials", icon: "mdi-newspaper", route: "/EditorialViewer" },
            { id: 15, title: "Calendar", icon: "mdi-calendar" },
          ],
        },
        {
          id: 2,
          title: "CRM",
          icon: "mdi-store",
          children: [
            { id: 21, title: "Sales Forecast", icon: "mdi-chart-line" },
            { id: 22, title: "Sales Quotation", icon: "mdi-file-document-outline" },
            { id: 23, title: "Sales Orders", icon: "mdi-cart", route: "/salesorderslist" },
            { id: 24, title: "Sales Leads", icon: "mdi-account-switch", route: "/salesleads" },
            { id: 25, title: "Leads", icon: "mdi-account-multiple", route: "/leads" },
            { id: 26, title: "BRVARs", icon: "mdi-file-check", route: "/brvars" },
            { id: 27, title: "Customers", icon: "mdi-account-group", route: "/customersummary" },
          ],
        },
        {
          id: 3,
          title: "Stats",
          icon: "mdi-chart-line",
          children: [
            { id: 31, title: "KPIs", icon: "mdi-chart-areaspline" },
            { id: 32, title: "Incentives", icon: "mdi-cash" },
            { id: 33, title: "Employee Appraisal", icon: "mdi-account-star-outline", route: "/employeeappraisal" },
            { id: 34, title: "Appraisal Report", icon: "mdi-file-chart", route: "/AppraisalViewer", isNew: true },
          ],
        },
        {
          id: 4,
          title: "Operations",
          icon: "mdi-cog",
          children: [
            { id: 41, title: "Payment Collection", icon: "mdi-cash-register", route: "/collections" },
            { id: 42, title: "Pick-lists", icon: "mdi-format-list-checkbox" },
            { id: 43, title: "Despatch", icon: "mdi-truck-delivery", route: "/despatch" },
            { id: 44, title: "Deliveries", icon: "mdi-package-variant", route: "/deliveries" },
          ],
        },
      ],
      app_menu_items:[
        {
          title: "Verify Device",
          route: "/deviceregister",
          icon: "mdi-account",
          visibility: "",
        },   
      ],
      
     

      adminMenus: {
        adminMenu: [
          {
            active: false,
            icon: "mdi-account",
            title: "Admin",
            visibility: "",
            items: [
              {
                title: "APP Users",
                route: "/usersAdmin",
                icon: "mdi-account-multiple",
                visibility: "",
              },
              {
                title: "Attendance",
                route: "/comingsoon",
                icon: "mdi-timer-check-outline",
                visibility: "",
              },
            ],
          },
        ],
        appraisalMenu: [
          {
            active: false,
            icon: "mdi-hand-clap",
            title: "Appraisal",
            visibility: "",
            items: [
              {
                // title: "Appraisers",
                // subItems: [
                  // {
                    title: "Appraisers",
                    route: "/appraisers",
                    icon: "mdi-account",
                    visibility: "",
                  // },
                // ],
              },
              {
                // title: "Appraisal Questions",
                // subItems: [
                  // {
                    title: "Questions",
                    route: "/appraisalQuestions",
                    icon: "mdi-table-question",
                    visibility: "",
                //   },
                // ],
              },
              {
                title: "Results",
                icon: "mdi-chart-line",
                subItems: [
                  {
                    title: "Individual",
                    route: "/appraisalResults",
                    icon: "mdi-chart-bar",
                    visibility: "",
                  },
                  {
                    title: "Summary",
                    route: "/appraisalSummary",
                    icon: "mdi-chart-bar-stacked",
                    visibility: "",
                  },
                ],
              },
              
            ],
          },
        ],
        appMenu: [
          {
            active: false,
            icon: "mdi-cog-outline",
            title: "Developer",
            visibility: "",
            items: [
              {
                title: "Banners",
                route: "/banners",
                icon: "mdi-image",
                visibility: "",
              },
              {
                title: "Notifications",
                route: "/NotificationsAdmin",
                icon: "mdi-bell",
                visibility: "",
              },
              {
                title: "Uploads",
                route: "/file_upload",
                icon: "mdi-upload",
                visibility: "",
              },
              {
                title: "Notification Send",
                route: "/notificationsend",
                icon: "mdi-send",
                visibility: "",
              },
              {
                title: "Register Device",
                route: "/deviceregister",
                icon: "mdi-cellphone-link",
                visibility: "",
              },
              {
                title: "API Settings",
                route: "/appsettings",
                icon: "mdi-cog",
                visibility: "",
              },
            ],
          },
        ],
        messMenu: [
          {
            active: false,
            icon: "mdi-food-outline",
            title: "Meals",
            visibility: "",
            items: [
              {
                title: "Orders",
                route: "/comingsoon",
                icon: "mdi-new-box",
                visibility: "",
              },
              {
                title: "Schedules",
                route: "/comingsoon",
                icon: "mdi-new-box",
                visibility: "",
              },
              {
                title: "Menus",
                route: "/comingsoon",
                icon: "mdi-new-box",
                visibility: "",
              },
            ],
          },
        ],
        logisticMenu: [
          {
            active: false,
            icon: "mdi-train-car",
            title: "Logistics",
            visibility: "",
            items: [
              {
                title: "Dashboard",
                route: "/logisticsDashboard",
                icon: "mdi-monitor-dashboard",
                visibility: "",
              },
              {
                title: "Fleets",
                icon: "mdi-bus-multiple",
                subItems: [                
                  
                  {
                    title: "Requests",
                    route: "/comingsoon",
                    icon: "mdi-social-distance-6-feet",
                    visibility: "",
                  },
                  {
                    title: "Schedules",
                    route: "/comingsoon",
                    icon: "mdi-airplane-clock",
                    visibility: "",
                  },
                  {
                    title: "Transits",
                    route: "/comingsoon",
                    icon: "mdi-truck-cargo-container",
                    visibility: "",
                  },
                ],
              },
              {
                title: "Vehicles",
                icon: "mdi-rv-truck",
                subItems: [
                  {
                    title: "Vehicles",
                    route: "/comingsoon",
                    icon: "mdi-format-list-checkbox",
                    visibility: "",
                  },
                  {
                    title: "Fuels",
                    route: "/comingsoon",
                    icon: "mdi-gas-station-outline",
                    visibility: "",
                  },
                  {
                    title: "Fines",
                    route: "/comingsoon",
                    icon: "mdi-ticket-outline",
                    visibility: "",
                  },  
                  {
                    title: "Repairs",
                    route: "/comingsoon",
                    icon: "mdi-car-wrench",
                    visibility: "",
                  },                
                ],
              },
              {
                title: "Drivers",                
                icon: "mdi-account-group",
                subItems: [
                  {
                    title: "Drivers",
                    route: "/comingsoon",
                    icon: "mdi-contacts",
                    visibility: "",
                  },
                  {
                    title: "Contacts",
                    route: "/comingsoon",
                    icon: "mdi-contacts-outline",
                    visibility: "",
                  },
                ]
              },
            ],
          },
        ],
        accomodationMenu: [
          {
            active: false,
            icon: "mdi-office-building-marker",
            title: "Housing",
            visibility: "",
            items: [
              {
                title: "Tentants",
                route: "/comingsoon",
                icon: "mdi-new-box",
                visibility: "",
                disabled:true,
              },
              {
                title: "Accomodations",
                route: "/comingsoon",
                icon: "mdi-new-box",
                visibility: "",
                disabled:true,
              },
              {
                title: "Maintainance",
                route: "/comingsoon",
                icon: "mdi-new-box",
                visibility: "",
                disabled:true,
              },
              {
                title: "House Keeping",
                route: "/comingsoon",
                icon: "mdi-new-box",
                visibility: "",
                disabled:true,
              },

            ],
          },
        ],
      },    
    };
  },

  created(){
    this.checkUpdate()
  },
  mounted(){
    this.$store.dispatch('checkPushNotificationPermission');
    this.$store.dispatch('checkLocationPermission');
  }
};
</script>

<style scoped>
.v-treeview-node__root {
  min-height: 40px;
}
.menu-text {
  font-size: 12px;
}
.app-version {
  text-align: center;
  font-style: italic;
}
.check-version{
  padding: 10px;
  
}
.new-notification {
  color: green;
  font-weight: bold;
}
.highlight-new {
    background: yellow;
}
/* Styles for the update notification paragraph */
.update-notification {
  /* display: none;  */
  /* Hide the paragraph by default */
  padding: 10px;
  background-color: #ffcc66;
}

/* Styles for the update button */
.update-button {
  margin-left: 10px;
  padding: 5px 10px;
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.checkupdate {
display: block;
}
/* Show the update notification if the updateAvailable data property is true */
.update-notification[data-v-xxx]:not([hidden]) {
  display: inline-block;
}

/* Show the update button if the showUpdateButton data property is true */
.update-button[data-v-xxx]:not([hidden]) {
  display: inline-block;
}
.drawer-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 10px;
  z-index: 2;
}

.card {
  height: 10px;
}
/* .rotate-icon {
  transform: rotate(180deg);
} */
.animated-icon {
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
}

.rotate-infinite {
  animation-name: rotate-infinite;
  animation-iteration-count: infinite;
}

@keyframes rotate-infinite {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.v-dialog__content {
  max-width: none !important;
}
.v-card {
  border-radius: 0 !important;
}
.nav-drawer-grid {
  display: grid;
  grid-template-rows: 1fr auto;
  height: 100%;
}

@media screen and (min-width: 600px) {
  .nav-drawer-grid {
    grid-template-rows: 1fr auto auto;
  }

  .logout-button-container {
    grid-row: 2;
  }
}
</style>
